"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = require("styled-components");
const component_text_1 = require("@patternplate/component-text");
exports.SearchResultListHeading = styled_components_1.default(component_text_1.Text) `
  box-sizing: border-box;
  position: -webkit-sticky;
  position: sticky;
  z-index: 1;
  top: 0;
  margin: 0;
  font-size: 14px;
  padding: 3px 15px;
  border-width: 1px 0;
  border-style: solid;
  border-color: ${props => props.theme.colors.border};
  color: ${props => props.theme.colors.color};
  background: ${props => props.theme.colors.background};
`;
//# sourceMappingURL=search-result-list-heading.js.map